module.exports = __webpack_public_path__ + "media/images/logo-quickbooks-bbcae1ad9ccdd77447a80b895c4f15a9.png";